<script setup lang="ts">
import CheckIcon from '@/assets/icons/CheckIcon.vue';

defineProps<{
  label?: string;
}>();
</script>

<template>
  <span class="status-chip bg-surface-green text-on-tint">
    <CheckIcon class="size-icon-smd shrink-0" aria-hidden="true" />
    {{ label ?? $t('general.completed') }}
  </span>
</template>
